import { memo } from "react";
import {
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg
    viewBox="0 0 256 256"
    {...otherProps}
    height={size}
    width={size}
    fill={`${color}`}
  >
    <_Rect width="256" height="256" fill="none" />
    <_Path d="M223.9,65.4l-12.2,66.9A24,24,0,0,1,188.1,152H72.1l4.4,24H184a24,24,0,1,1-24,24,23.6,23.6,0,0,1,1.4-8H102.6a23.6,23.6,0,0,1,1.4,8,24,24,0,1,1-42.2-15.6L34.1,32H16a8,8,0,0,1,0-16H34.1A16,16,0,0,1,49.8,29.1L54.7,56H216a7.9,7.9,0,0,1,6.1,2.9A7.7,7.7,0,0,1,223.9,65.4Z" />
  </_Svg>;
};
Icon.displayName = "ShoppingCartFill";
const ShoppingCartFill = memo(themed(Icon));
export {
  ShoppingCartFill
};
//# sourceMappingURL=shopping-cart-fill.js.map
